<ng-template #headerTemplate><ng-content select="kb-panel-header"/></ng-template>
<ng-template #contentTemplate><ng-content select="kb-panel-content,ng-template[kb-panel-content]"/></ng-template>
